
import CadminCompaniesAx         from 'app/actions/company-admin/companies';
import CadminGroupsAx            from 'app/actions/company-admin/groups';
import CadminVolEventsDuck       from 'app/ducks/company-admin/vol-events';
import paths                     from 'app/paths';
import history                   from 'app/history';
import CadminSlx                 from 'app/selectors/company-admin/';
import PageSlx                   from 'app/selectors/company-admin/page-vol-events';

const Types = {
  LOAD: 'CADMIN_PAGE_VOL_EVENTS_LOAD',
};

const Actions = {

  load: ({params: {companySlug}, query}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminCompaniesAx.loadCommon(companySlug)),
      dispatch(CadminVolEventsDuck.Ax.search(companySlug, query)),
      ...(query.groupId ? [
        dispatch(CadminGroupsAx.get(companySlug, query.groupId))
      ] : []),
    ]);
    return dispatch({type: Types.LOAD, promise});
  },

  setSearchParams: (newParams) => (dispatch, getState) => {
    const state = getState();
    const companySlug = CadminSlx.companySlug(state);
    const currentParams = PageSlx.searchParams(state);
    const params = {...currentParams, ...newParams};
    const path = paths.cadminVolEvents(companySlug, params);
    history.push(path);
  },

};

export {
  Types,
};

export default Actions;
